module.exports = __webpack_public_path__ + "static/media/Event-Carousels-Wedding.edcf5a9e.jpg";